var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.597,
    height: 23.281,
    viewBox: "0 0 34.597 23.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M4162.019,824.821h-3.054v-2.952a.75.75,0,0,0-.75-.75h-11.973v-1.958h3.032a.75.75,0,0,0,.75-.75V811.1a.75.75,0,0,0-.75-.75h-7.607a.75.75,0,0,0-.75.75v7.31a.75.75,0,0,0,.75.75h3.075v1.958h-12.017a.75.75,0,0,0-.75.75v2.952h-3.053a.75.75,0,0,0-.75.75v7.311a.75.75,0,0,0,.75.75h7.607a.75.75,0,0,0,.75-.75v-7.311a.75.75,0,0,0-.75-.75h-3.054v-2.2h11.267v2.2h-3.075a.75.75,0,0,0-.75.75v7.311a.75.75,0,0,0,.75.75h7.607a.75.75,0,0,0,.75-.75v-7.311a.75.75,0,0,0-.75-.75h-3.032v-2.2h11.223v2.2h-3.053a.75.75,0,0,0-.75.75v7.311a.75.75,0,0,0,.75.75h7.607a.75.75,0,0,0,.75-.75v-7.311A.75.75,0,0,0,4162.019,824.821Zm-19.6-12.97h6.107v5.81h-6.107Zm-6.638,20.281h-6.107v-5.811h6.107Zm12.745,0h-6.107v-5.811h6.107Zm12.745,0h-6.107v-5.811h6.107Z",
    transform: "translate(-4128.172 -810.351)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionsIcon);
export default __webpack_public_path__ + "static/media/sections-icon.b86f01f42e7e32df3c13dbe774af40db.svg";
export { ForwardRef as ReactComponent };